<template>
  <div class="table-responsive-lg">
    <table class="table table-striped blue items-with-sub-lines">
      <thead>
        <tr>
          <th>#{{ getContentItem("PartNumber") }}#</th>
          <th>{{ getContentItem("Description") }}</th>
          <th class="text-right">
            {{ getContentItem("qty") }}
          </th>
          <th class="text-right">
            {{ getContentItem("UnitPrice") }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, index) in details.Items">
          <tr :key="index">
            <template v-if="item.PartNumber === 'M'">
              <td class="muted">
                <em>{{ getContentItem("comment") }}</em>
              </td>
              <td colspan="100%" class="muted">
                {{ item.Description }}
              </td>
            </template>
            <template v-else>
              <td>{{ item.PartNumber }}</td>
              <td>{{ item.Description }}</td>
              <td class="text-right">
                {{ item.OrderedQuantity }}
              </td>
              <td class="text-right">
                <currency-text :amount="item.Price" :currency-code="details.CurrencyCode" />
              </td>
            </template>
          </tr>
        </template>
      </tbody>
      <tfoot>
        <tr v-if="details.SubTotal" class="row-total">
          <td colspan="3" class="text-right">
            <label for="grandTotal">{{ getContentItem("grandTotal") }}:</label>
          </td>
          <td>
            <currency-text
              id="grandTotal"
              :amount="details.SubTotal"
              :currency-code="details.CurrencyCode"
            />
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { CurrencyText } from "@/components/Elements";

  export default {
    name: "QuoteDetailsGrid",
    components: {
      CurrencyText
    },
    computed: {
      ...mapGetters(["getContentItem"])
    },
    props: {
      details: Object
    }
  };
</script>
